module.exports = __webpack_public_path__ + "img/cta-prizes.6f1ed8e0.png";